import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
import PregnancyEducationalContent from "./PregnancyEducationalContent";
const TITLE = `حاسبة الحمل - احسبي موعد الولادة بدقة`;
const DESCRIPTION = `حاسبة الحمل الدقيقة لحساب موعد الولادة المتوقع وعمر الحمل بالأسابيع والأشهر. أدخلي تاريخ آخر دورة شهرية لمعرفة موعد الولادة، مراحل نمو الجنين، وأيام التبويض. حاسبة حمل دقيقة بالميلادي والهجري مع شرح تفصيلي لكل مرحلة من مراحل الحمل.`;
const KEYWORDS = `حاسبة الحمل, حساب موعد الولادة, حاسبة الحمل الدقيقة, حساب الحمل بالأسابيع, حساب الحمل بالأشهر, حاسبة الحمل بالهجري, موعد الولادة المتوقع, عمر الحمل, مراحل الحمل, أيام التبويض, حساب فترة الحمل, pregnancy calculator, متى ألد, حاسبة الولادة, حساب أسابيع الحمل`;
const OG_URL = "https://do-calculate.com/calculator/ar/pregnancy/";

const GREGORIAN_MONTHS = [
  "يناير / كانون الثاني", "فبراير / شباط", "مارس / آذار", "أبريل / نيسان",
  "مايو / أيار", "يونيو / حزيران", "يوليو / تموز", "أغسطس / آب",
  "سبتمبر / أيلول", "أكتوبر / تشرين الأول", "نوفمبر / تشرين الثاني", "ديسمبر / كانون الأول"
];
function PregnancyCalculator() {
  // حالة التاريخ المنفصلة
  const [dateInput, setDateInput] = useState({
    day: new Date().getDate(),
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear()
  });

  const [cycleLength, setCycleLength] = useState(28);
  const [lastPeriodError, setLastPeriodError] = useState("");
  const [cycleLengthError, setCycleLengthError] = useState("");
  const [result, setResult] = useState(null);

  const addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  const getDayOfWeek = (date) => {
    const days = ["الأحد", "الإثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"];
    return days[date.getDay()];
  };

  const getSeason = (month) => {
    if (month >= 3 && month <= 5) return "الربيع";
    if (month >= 6 && month <= 8) return "الصيف";
    if (month >= 9 && month <= 11) return "الخريف";
    return "الشتاء";
  };

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const calculateDaysBetween = (date1, date2) => {
    const diffTime = Math.abs(date2 - date1);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
    const newDateInput = { ...dateInput, [name]: value };
    setDateInput(newDateInput);

    const selectedDate = new Date(newDateInput.year, newDateInput.month - 1, newDateInput.day);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (selectedDate > today) {
      setLastPeriodError("التاريخ يجب أن يكون في الماضي");
    } else {
      const diffDays = calculateDaysBetween(selectedDate, today);
      if (diffDays > 365) {
        setLastPeriodError("التاريخ يبدو بعيداً جداً في الماضي");
      } else {
        setLastPeriodError("");
      }
    }
  };

  const handleCycleLengthChange = (event) => {
    const value = event.target.value;
    if (value !== "") {
      const parsedValue = parseInt(value);
      if (!isNaN(parsedValue) && parsedValue >= 20 && parsedValue <= 45) {
        setCycleLength(parsedValue);
        setCycleLengthError("");
      } else {
        setCycleLength(value);
        if (isNaN(parsedValue)) {
          setCycleLengthError("تأكدي من إدخال رقم صحيح");
        } else if (parsedValue < 20) {
          setCycleLengthError("طول الدورة يجب أن يكون 20 يوماً على الأقل");
        } else if (parsedValue > 45) {
          setCycleLengthError("طول الدورة يجب ألا يزيد عن 45 يوماً");
        }
      }
    } else {
      setCycleLength("");
      setCycleLengthError("");
    }
  };

  const handleReset = () => {
    setDateInput({
      day: new Date().getDate(),
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear()
    });
    setCycleLength(28);
    setLastPeriodError("");
    setCycleLengthError("");
    setResult(null);
  };

  const calculatePregnancy = (e) => {
    e.preventDefault();
    const lmpDate = new Date(dateInput.year, dateInput.month - 1, dateInput.day);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (isNaN(lmpDate.getTime()) || lastPeriodError) return;

    const conceptionDate = addDays(lmpDate, cycleLength - 14);
    const dueDate = addDays(lmpDate, 280);
    const daysSinceLMP = calculateDaysBetween(lmpDate, today);
    const weeksSinceLMP = Math.floor(daysSinceLMP / 7);
    const remainingDays = daysSinceLMP % 7;
    const daysUntilDue = calculateDaysBetween(today, dueDate);

    let trimester = weeksSinceLMP < 13 ? "الثلث الأول" : weeksSinceLMP < 27 ? "الثلث الثاني" : "الثلث الثالث";

    setResult({
      lmpDate: formatDate(lmpDate),
      conceptionDate: formatDate(conceptionDate),
      dueDate: formatDate(dueDate),
      dueDateDay: getDayOfWeek(dueDate),
      dueDateSeason: getSeason(dueDate.getMonth()),
      currentWeek: weeksSinceLMP,
      currentDay: remainingDays,
      currentMonth: Math.floor(weeksSinceLMP / 4) + 1,
      trimester: trimester,
      daysUntilDue: daysUntilDue,
      totalDays: daysSinceLMP
    });
  };
  // Generate Schema.org structured data
  const generateSchemaData = () => {
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "الصفحة الرئيسية",
          item: "https://do-calculate.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "الحاسبات",
          item: "https://do-calculate.com/ar/all-calculators/",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "حاسبة الحمل",
          item: OG_URL,
        },
      ],
    };
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "كيف أحسب موعد الولادة؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "لحساب موعد الولادة، أدخلي تاريخ أول يوم من آخر دورة شهرية في حاسبة الحمل. يتم إضافة 280 يوماً (40 أسبوعاً) لتحديد موعد الولادة المتوقع باستخدام قاعدة نيغل الطبية.",
          },
        },
        {
          "@type": "Question",
          name: "ما هي مدة الحمل الطبيعية؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "مدة الحمل الطبيعية تتراوح بين 37 إلى 42 أسبوعاً، بمتوسط 40 أسبوعاً (280 يوماً) من أول يوم في آخر دورة شهرية. معظم الولادات تحدث بين الأسبوع 38 والأسبوع 42.",
          },
        },
        {
          "@type": "Question",
          name: "كيف أعرف في أي أسبوع من الحمل أنا؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "لمعرفة أسبوع الحمل الحالي، احسبي عدد الأسابيع من تاريخ أول يوم في آخر دورة شهرية حتى اليوم الحالي. استخدمي حاسبة الحمل للحصول على النتيجة الدقيقة مع تفاصيل إضافية عن مراحل نمو الجنين.",
          },
        },
        {
          "@type": "Question",
          name: "ما الفرق بين حساب الحمل بالأسابيع والأشهر؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "حساب الحمل بالأسابيع أكثر دقة طبياً ويستخدمه الأطباء لمتابعة نمو الجنين. الحساب بالأشهر أسهل للفهم حيث كل 4 أسابيع تقريباً تساوي شهراً واحداً، لكن الأطباء يفضلون الأسابيع للدقة.",
          },
        },
        {
          "@type": "Question",
          name: "هل حاسبة الحمل دقيقة؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "حاسبة الحمل دقيقة إذا كانت دورتك الشهرية منتظمة وتتذكرين تاريخ آخر دورة بدقة. للتأكد الكامل، يجب زيارة الطبيب لإجراء فحص السونار الذي يحدد عمر الحمل بدقة أكبر.",
          },
        },
      ],
    };
    const calculatorSchema = {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      name: "حاسبة الحمل",
      description: DESCRIPTION,
      url: OG_URL,
      applicationCategory: "HealthApplication",
      operatingSystem: "Any",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
      },
    };
    return [breadcrumbSchema, faqSchema, calculatorSchema];
  };
  return (
    <div className="rtl" style={{ direction: "rtl" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        SCHEMA={generateSchemaData()}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ padding: "15px", borderRadius: "12px" }}
          >
            <h1 style={{ fontSize: "22px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            {/* Introduction */}
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                <strong>حاسبة الحمل</strong> هي أداة طبية مجانية ودقيقة لحساب{" "}
                <strong>موعد الولادة المتوقع</strong> وتحديد{" "}
                <strong>عمر الحمل</strong> بالأسابيع والأشهر. كل ما تحتاجينه هو
                إدخال تاريخ أول يوم من آخر دورة شهرية للحصول على معلومات شاملة
                عن حملك، بما في ذلك{" "}
                <strong>مراحل نمو الجنين</strong> والفحوصات المطلوبة في كل
                مرحلة.
              </p>
            </div>
            <hr />
            <MobileUnderCalAds />
            {/* Calculator Section */}
            <div className="row">
              <div className="col-sm-12 col-md-6 calculatorStyle">
                <div className="p-3 mb-3 bg-success text-white text-center rounded">
                  <h2 style={{ fontSize: "18px", margin: 0 }}>
                    احسبي موعد الولادة
                  </h2>
                </div>
                <form onSubmit={calculatePregnancy}>
                  <div className="form-group mb-3">
                    <label ><strong>أول يوم في آخر دورة شهرية:</strong></label>
                    <div className="d-flex gap-2">
                      <select style={{width:'100px'}} className="form-control" name="day" value={dateInput.day} onChange={handleDropdownChange}>
                        {Array.from({ length: 31 }, (_, i) => i + 1).map(d => <option key={d} value={d}>{d}</option>)}
                      </select>
                      <select style={{width:'100%'}} className="form-control" name="month" value={dateInput.month} onChange={handleDropdownChange}>
                        {GREGORIAN_MONTHS.map((m, i) => <option key={i + 1} value={i + 1}>{i + 1} - {m}</option>)}
                      </select>
                      <select style={{width:'100px'}} className="form-control" name="year" value={dateInput.year} onChange={handleDropdownChange}>
                        {Array.from({ length: 3 }, (_, i) => new Date().getFullYear() - i).map(y => <option key={y} value={y}>{y}</option>)}
                      </select>
                    </div>
                    {lastPeriodError && <div className="text-danger mt-1" style={{ fontSize: "14px" }}>{lastPeriodError}</div>}
                  </div>

                  <div className="form-group mb-4">
                    <label ><strong>متوسط طول الدورة الشهرية (بالأيام):</strong></label>
                    <div className="d-flex align-items-center">
                      <input type="number" className="form-control" value={cycleLength} onChange={handleCycleLengthChange} min="20" max="45" required style={{ maxWidth: "150px" }} />
                      <span style={{ marginRight: "10px", padding: "8px 15px", border: "1px solid #ced4da", borderRadius: "4px", backgroundColor: "#f9f9f9" }}>يوم</span>
                    </div>
                    {cycleLengthError && <div className="text-danger mt-1" style={{ fontSize: "14px" }}>{cycleLengthError}</div>}
                  </div>

                  <hr />
                  <div className="d-flex gap-2">
                    <button type="submit" className="btn bg-success text-white" style={{ padding: "10px 30px" }}>احسب</button>
                    <button type="button" className="btn btn-secondary" onClick={handleReset} style={{ padding: "10px 30px", marginRight: "10px" }}>امسح</button>
                  </div>
                </form>
              </div>
              <div className="col-sm-12 col-md-6">
                {result && (
                  <div className="calculatorStyle">
                    <div className="p-3 mb-3 bg-success text-white text-center rounded">
                      <h3 style={{ fontSize: "18px", margin: 0 }}>النتيجة</h3>
                    </div>
                    <div className="alert alert-success" style={{ fontSize: "16px" }}>
                      <table className="table table-bordered" style={{ width: "100%", marginBottom: 0 }}>
                        <tbody>
                          <tr>
                            <td style={{ textAlign: "center", backgroundColor: "#e7f3fe", padding: "12px" }}>
                              <strong>موعد الولادة المتوقع:</strong>
                            </td>
                            <td style={{ textAlign: "center", backgroundColor: "#e7f3fe", padding: "12px" }}>
                              <strong style={{ fontSize: "18px", color: "#1a5f3f" }}>
                                {result.dueDate}
                              </strong>
                              <br />
                              <small>يوم {result.dueDateDay} في فصل {result.dueDateSeason}</small>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ textAlign: "center", backgroundColor: "#fff3cd", padding: "12px" }}>
                              <strong>عمر الحمل الحالي:</strong>
                            </td>
                            <td style={{ textAlign: "center", backgroundColor: "#fff3cd", padding: "12px" }}>
                              <strong style={{ fontSize: "18px", color: "#856404" }}>
                                {result.currentWeek} أسبوع و {result.currentDay} يوم
                              </strong>
                              <br />
                              <small>({result.currentMonth} شهر تقريباً)</small>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ textAlign: "center", backgroundColor: "#d1ecf1", padding: "12px" }}>
                              <strong>المرحلة الحالية:</strong>
                            </td>
                            <td style={{ textAlign: "center", backgroundColor: "#d1ecf1", padding: "12px" }}>
                              <strong style={{ fontSize: "18px", color: "#0c5460" }}>
                                {result.trimester}
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ textAlign: "center", backgroundColor: "#d4edda", padding: "12px" }}>
                              <strong>المدة المتبقية:</strong>
                            </td>
                            <td style={{ textAlign: "center", backgroundColor: "#d4edda", padding: "12px" }}>
                              <strong style={{ fontSize: "18px", color: "#155724" }}>
                                {result.weeksUntilDue} أسبوع و {result.remainingDaysUntilDue} يوم
                              </strong>
                              <br />
                              <small>({result.daysUntilDue} يوم)</small>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ textAlign: "center", backgroundColor: "#f8d7da", padding: "12px" }}>
                              <strong>تاريخ الإخصاب المتوقع:</strong>
                            </td>
                            <td style={{ textAlign: "center", backgroundColor: "#f8d7da", padding: "12px" }}>
                              <strong style={{ fontSize: "16px", color: "#721c24" }}>
                                {result.conceptionDate}
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ textAlign: "center", backgroundColor: "#d4edda", padding: "12px" }}>
                              <strong>لقد أكملتي:</strong>
                            </td>
                            <td style={{ textAlign: "center", backgroundColor: "#d4edda", padding: "12px" }}>
                              <strong style={{ fontSize: "16px", color: "#0c5460" }}>
                                {/* put result in percentage */}
                                {((result.totalDays / 280) * 100).toFixed(2)}%
                                من الحمل
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div
              className="alert alert-info"
              style={{ fontSize: "15px", lineHeight: "1.8" }}
            >
              <strong>💡 ملاحظة مهمة:</strong> هذه النتائج تقديرية بناءً على قاعدة نيغل الطبية.
              لتحديد موعد الولادة بدقة أكبر، يُنصح بزيارة الطبيب وإجراء فحص السونار في الأسابيع
              الأولى من الحمل.
            </div>
            <hr />
            {/* Related Links */}
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>
      {/* Educational Content Section */}
      <PregnancyEducationalContent />
      <br />
    </div>
  );
}
export default PregnancyCalculator;